<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="sp" id="epig"> </p>
<p class="FM-Epigraph-non-verse-fmepi"><span epub:type="pagebreak" id="pg_xiii" title="xiii">I woke up as the sun was reddening; and that was the one distinct time in my life, the strangest moment of all, when I didn’t know who I was—I was far away from home, haunted and tired … I was halfway across America, at the dividing line between the East of my youth and the West of my future.</span></p>
<p class="FM-Epigraph-Source-fmeps">—<span class="fm-epigraph-source-fmeps-_CAPS">J</span><span class="ePub-SC">ACK</span> <span class="fm-epigraph-source-fmeps-_CAPS">K</span><span class="ePub-SC">EROUAC,</span> <span class="ePub-I">On the Road</span></p>
<p class="FM-Epigraph-non-verse-fmepi-first">When I woke, I didn’t know where I was or nothing, but I had a feeling something nice had happened.</p>
<p class="FM-Epigraph-Source-fmeps">—<span class="fm-epigraph-source-fmeps-_CAPS">R</span><span class="ePub-SC">OCKY</span> <span class="fm-epigraph-source-fmeps-_CAPS">M</span><span class="ePub-SC">ARCIANO,</span> the morning after becoming heavyweight champion of the world</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?a9b4e61e